import { ArrowLeft } from 'lucide-react';
import { useCompany } from '@/contexts/CompanyContext';
import { supplierInitials } from './supplierInitials';

/**
 * Shown between the top bar and the content while an account manager works inside a
 * customer (same slot as the test-mode banner): who they are helping, as whom, and
 * the way back. Renders nothing outside a supplier session.
 */
export function SupplierBanner() {
  const { isSupplierSession, activeCompanyName, supplierOrg, leaveSupplierSession } = useCompany();
  if (!isSupplierSession) return null;
  const supplierName = supplierOrg?.name ?? 'leverandør';
  const customerName = activeCompanyName;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b-2 border-primary bg-primary-50 px-4 py-2 text-[13px] text-dark dark:bg-primary-900/30 dark:text-dark-text sm:px-6"
    >
      <span
        aria-hidden="true"
        className="flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-md bg-primary text-[9px] font-extrabold text-white"
      >
        {supplierInitials(supplierName)}
      </span>
      <span>
        Du hjælper {customerName ? <strong>{customerName}</strong> : 'kunden'} som {supplierName}
      </span>
      <button
        type="button"
        onClick={leaveSupplierSession}
        className="inline-flex items-center gap-1.5 whitespace-nowrap font-bold text-primary hover:underline dark:text-primary-400 sm:ml-auto"
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        Tilbage til {supplierName}
      </button>
    </div>
  );
}
